var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 246,
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3604 186.785C51.3284 177.751 44.0914 166.921 39.3499 155.292C26.7725 124.447 32.6619 87.763 57.2178 62.4584L79.8771 85.1177C81.1249 86.3655 83.3709 85.4671 83.6703 83.6204L96.0481 2.61581C96.2478 1.26823 95.0998 0.120287 93.7522 0.319929L12.6977 12.6977C10.851 12.9972 9.95264 15.2431 11.2004 16.4909L33.9096 39.2001C-3.57309 77.5314 -9.96162 135.028 14.6442 179.948C22.031 193.473 32.2626 205.851 45.2892 216.232C67.4494 233.851 94.7005 242.286 121.752 241.737L126.843 208.446C103.535 210.443 79.5777 203.256 61.3604 186.785Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.09 206.799C249.573 168.468 255.961 110.971 231.355 66.052C223.969 52.5262 213.737 40.1485 200.71 29.7671C178.55 12.1487 151.299 3.71384 124.248 4.26286L119.157 37.5531C142.415 35.5567 166.422 42.7438 184.639 59.2142C194.671 68.248 201.908 79.0786 206.65 90.7077C219.227 121.552 213.338 158.237 188.782 183.541L166.122 160.882C164.875 159.634 162.629 160.532 162.329 162.379L149.951 243.384C149.752 244.731 150.9 245.879 152.247 245.68L233.302 233.302C235.148 233.002 235.997 230.756 234.799 229.509L212.09 206.799Z",
    fill: "#7C7C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5b537692.svg";
export { ForwardRef as ReactComponent };